import * as React from 'react'

function SvgVideoOn(props, svgRef) {
  return (
    <svg viewBox="0 0 24 16" fill="#204566" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.458 2.11A1 1 0 0124 3v10a1 1 0 01-1.581.814l-7-5a1 1 0 010-1.628l7-5a1 1 0 011.039-.075zM17.72 8L22 11.057V4.943L17.72 8z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 2a1 1 0 00-1 1v10a1 1 0 001 1h11a1 1 0 001-1V3a1 1 0 00-1-1H3zM0 3a3 3 0 013-3h11a3 3 0 013 3v10a3 3 0 01-3 3H3a3 3 0 01-3-3V3z"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgVideoOn)
export default ForwardRef
